import { PAYROLL_PROVIDER_FLAGS } from '@neo.tax/shared/constants';
import { PayrollProvider } from '@neo.tax/shared/graphql';
import { useFlags } from '@neo.tax/shared/third-parties';

import { PayrollProviderCardProps } from '../connect-account.types';
import { toPayrollProviderCards } from '../connect-account.utils';
import { usePayrollProviderIds } from './usePayrollProviderIds';

export const usePayrollProviderCards = ({
  connectedProviders,
  enabled,
}: {
  enabled: boolean;
  connectedProviders: Set<PayrollProvider>;
}): PayrollProviderCardProps[] => {
  const payrollAccountIds = usePayrollProviderIds();
  const flags = useFlags();
  if (!enabled) return [];

  const payrollIds: {
    provider: PayrollProvider;
    analyticId: string;
    connected: boolean;
  }[] = [
    {
      provider: PayrollProvider.Gusto,
      analyticId: payrollAccountIds.gustoRadioId,
      connected: connectedProviders.has(PayrollProvider.Gusto),
    },
    {
      provider: PayrollProvider.Justworks,
      analyticId: payrollAccountIds.justworksRadioId,
      connected: connectedProviders.has(PayrollProvider.Justworks),
    },
    {
      provider: PayrollProvider.Rippling,
      analyticId: payrollAccountIds.ripplingRadioId,
      connected: connectedProviders.has(PayrollProvider.Rippling),
    },
    {
      provider: PayrollProvider.Trinet,
      analyticId: payrollAccountIds.trinetRadioId,
      connected: connectedProviders.has(PayrollProvider.Trinet),
    },
    {
      provider: PayrollProvider.Quickbooks,
      analyticId: payrollAccountIds.quickbooksRadioId,
      connected: connectedProviders.has(PayrollProvider.Quickbooks),
    },
    {
      provider: PayrollProvider.AdpRun,
      analyticId: payrollAccountIds.adpRunRadioId,
      connected: connectedProviders.has(PayrollProvider.AdpRun),
    },
    {
      provider: PayrollProvider.AdpWorkforceNow,
      analyticId: payrollAccountIds.adpWorkforceNowRadioId,
      connected: connectedProviders.has(PayrollProvider.AdpWorkforceNow),
    },
    {
      provider: PayrollProvider.CeridianDayforce,
      analyticId: payrollAccountIds.ceridianDayforceRadioId,
      connected: connectedProviders.has(PayrollProvider.CeridianDayforce),
    },
    {
      provider: PayrollProvider.PaychexFlex,
      analyticId: payrollAccountIds.payChexFlexRadioId,
      connected: connectedProviders.has(PayrollProvider.PaychexFlex),
    },
    {
      provider: PayrollProvider.Paylocity,
      analyticId: payrollAccountIds.paylocityRadioId,
      connected: connectedProviders.has(PayrollProvider.Paylocity),
    },
    {
      provider: PayrollProvider.Workday,
      analyticId: payrollAccountIds.workdayRadioId,
      connected: connectedProviders.has(PayrollProvider.Workday),
    },
    {
      provider: PayrollProvider.Zenefits,
      analyticId: payrollAccountIds.zenefitsRadioId,
      connected: connectedProviders.has(PayrollProvider.Zenefits),
    },
    {
      provider: PayrollProvider.SelfReported,
      analyticId: payrollAccountIds.csvRadioId,
      connected: connectedProviders.has(PayrollProvider.SelfReported),
    },
  ].filter(({ provider }) => PAYROLL_PROVIDER_FLAGS[provider] && flags[PAYROLL_PROVIDER_FLAGS[provider]]);
  return toPayrollProviderCards(payrollIds);
};
